<template>
  <v-container fluid class="admin-gym">
    <v-tabs v-model="tabIndex">
      <v-tab>{{ $t('admin_acc_gym_subscription_type.title') }}</v-tab>
      <v-tab-item>
        <GymSubscriptionTypeList v-if="tabIndex === 0"></GymSubscriptionTypeList>
      </v-tab-item>

      <v-tab>{{$t('admin_acc_gym_subscription.title')}}</v-tab>
      <v-tab-item>
        <AdminGymSubscriptionList full-height
                                  v-if="tabIndex === 1"></AdminGymSubscriptionList>
      </v-tab-item>

      <v-tab>{{$t('admin_acc_gym_booking.title')}}</v-tab>
      <v-tab-item>
        <AdminGymBookingList v-if="tabIndex === 2"></AdminGymBookingList>
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>


<script>
import {onMounted, ref} from "@vue/composition-api";
import AdminGymSubscriptionList from "@/components/acc_booking/AdminGymSubscriptionList";
import GymSubscriptionTypeList from "@/components/acc_booking/GymSubscriptionTypeList";
import AdminGymBookingList from "@/components/acc_booking/AdminGymBookingList";

export default {
  name: 'AccGym',
  components: {AdminGymBookingList, GymSubscriptionTypeList, AdminGymSubscriptionList},
  setup(props, {root}) {
    const tabIndex = ref(1);

    const tabChanged = function (index) {
      root.$router.replace({
        name: root.$route.name,
        params: root.$route.params,
        query: {...root.$route.query, t: index},
      });
    }

    onMounted(() => {
      setTimeout(() => {
        tabIndex.value = parseInt(root.$route.query.t || "0");
      }, 50)
    })

    return {
      tabIndex,
      tabChanged,
    }
  },
}
</script>

<style lang="less">
.admin-gym {
  .v-tabs {
    height: 100%;

    .v-tabs-bar {
      flex: 0 0 auto;
    }

    .v-tabs-items {
      height: calc(100% - 48px);
      flex: 1 1 0;

      .v-window__container {
        height: 100% !important;

        .v-window-item {
          height: 100% !important;
          display: flex;
          flex-direction: column;
          overflow-y: auto;
        }
      }
    }
  }
}
</style>
